<template>
  <div class="image-upload">
    <div v-if="src" class="image-upload-result">
      <ImageComponent :preview="previewSrc" :src="src" :height="'100'" />
      <span v-if="value.created_at">{{
        $t('imageUpload.addedAt', { date: formattedFromDateTime(value.created_at) })
      }}</span>
    </div>
    <label for="img" class="visually-hidden">{{ label }}</label>
    <input id="img" type="file" accept="image/*" @change="handleFileUpload" />
  </div>
</template>

<script>
import ImageComponent from '@/components/Image'
import dateUtils from '@/components/mixins/dateUtils'

import { i18n } from '@/i18n'

// model should be the image object from the image serializer
// this will be updating the data attribute which get's accepted by active_storage_base64
export default {
  props: {
    value: { type: Object, required: false },
    label: { type: String, default: i18n.t('imageUpload.add.image') },
  },
  mixins: [dateUtils],
  components: { ImageComponent },
  computed: {
    previewSrc() {
      return this.value?.data || this.value?.preview_url
    },
    src() {
      return this.value?.data || this.value?.url
    },
  },
  methods: {
    handleFileUpload(event) {
      const reader = new FileReader()
      reader.onload = () => {
        this.$emit('input', { ...this.image, data: reader.result })
      }
      reader.readAsDataURL(event.target.files[0])
    },
  },
}
</script>

<style lang="scss">
.image-upload {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border: var(--vs-border-width) var(--vs-border-style) var(--vs-border-color);
  border-radius: var(--vs-border-radius);
  padding: 0.625rem;

  .image-upload-result {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    font-size: 0.825rem;

    img {
      display: block;
    }
  }
}
</style>
